import axios from "axios";
import { IPerson } from "redmond";
import { replaceObjectValues } from "@capone/common";

import { config } from "../../config";
import { passengersApiPrefix } from "../../paths";

const END_POINT: string = `${passengersApiPrefix}/upsert_by_business`;

export interface IUpsertPassengerByBusinessRequest {
  person: IPerson;
  businessId: string;
}

export const upsertPassengerByBusiness = async (
  body: IUpsertPassengerByBusinessRequest
): Promise<void> => {
  const cleanPersonPayload = replaceObjectValues(body.person, "", null);
  await axios.put(
    END_POINT,
    { person: cleanPersonPayload, businessId: body.businessId },
    { baseURL: config.baseURL }
  );
};
